const playVideo = {

  init() {
    const remoteVideos = document.querySelectorAll(".remote-video");

    remoteVideos.forEach(element => {
      const videos = element.querySelector(".remote-video__video");
      const thumbnail = element.querySelector(".remote-video__thumbnail");
      const button = element.querySelector(".button--video");
      const embedVideo = element.querySelector(".media-oembed-content");
      let times=0, play;

      button.addEventListener('click', function () {
        thumbnail.style.display = "none";
        button.style.display = "none";
        videos.style.display = "block";
        
        // if(times == 0) {
        //   play = embedVideo.src += '?autoplay=1';
        //   times = 1;
        // }
      });
    })
  }
}

playVideo.init();